import { KartType, Session, SessionType } from "../time/time.types";

export const generateEmptySession = (override?: Partial<Session>): Session => ({
  fastestLap: 0,
  id: undefined!,
  laps: [],
  competitors: 8,
  position: 1,
  type: SessionType.TRAINING,
  kartType: KartType.NINE,
  weight: 90,
  date: new Date(),
  name: "",
  trackId: "",
  userId: "",
  ...override,
});
